module.exports = __webpack_public_path__ + "img/no-tresorerie.92acdbfa.svg";